import vjsSrv from '../services/vjsSrv';
import { device } from 'vimmi-web-utils/cjs/device';
import $logger from 'src/js/logger';
import { deviceAsync } from 'vimmi-web-utils/cjs/deviceAsync';
let ctx = null;
export class AdsCustomUi {
  constructor(ads) {
    this.imaContainer = null;
    this.uiAdIdentifier = null;
    this.uiCustomClickBtn = null;
    this.uiCustomPlayBtn = null;
    this.clickThroughUrl = null;
    this.uiMuteContainer = null;
    this.imaViewTags = [];
    this.ads = ads;
    this.adsPaused = false;
    ctx = this;
  }

  wrapHtmlEl(el) {
    el.show = () => {
      el.classList.remove('d-none');
    };
    el.hide = () => {
      el.classList.add('d-none');
    };
  }

  get adsManager() {
    return vjsSrv.vjsPlayer.ima?.getAdsManager ? vjsSrv.vjsPlayer.ima.getAdsManager() : null;
  }

  addListeners() {
    vjsSrv.vjsPlayer.ima.addEventListener(google.ima.AdEvent.Type.LOADED, (adEvent) => {
      let ad = adEvent.getAd();
      let adData = adEvent.getAdData();
      this.clickThroughUrl = adData?.clickThroughUrl;
      if (this.ads.ad && !this.ads.ad.isLinear()) {
        return;
      }
      this.resetUIWrap();
      if (ad && ad.isLinear()) {
        this.updateUI(ad, adEvent.getAdData(), adEvent);
      }
    });
    vjsSrv.vjsPlayer.ima.addEventListener(google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED, (adEvent) => {
      this.clickThroughUrl = null;
      this.resetUIWrap();
      this.fixImaZIndex('unset');
      this.adsPaused = false;
    });
    vjsSrv.vjsPlayer.ima.addEventListener(google.ima.AdEvent.Type.COMPLETE, (adEvent) => {
      this.resetUIWrap();
      document.querySelector('.ima-ad-container').style.display = 'none';
    });
    vjsSrv.vjsPlayer.ima.addEventListener(google.ima.AdEvent.Type.SKIPPED, (adEvent) => {
      this.resetUIWrap();
      document.querySelector('.ima-ad-container').style.display = 'none';
    });
    vjsSrv.vjsPlayer.ima.addEventListener(google.ima.AdEvent.Type.STARTED, (adEvent) => {
      let ad = adEvent.getAd();
      // this._currentAd = ad;
      if (ad && ad.isLinear()) {
        if (vjsSrv.vjsPlayer.ima.controller.getSettings().syncVolume) {
          vjsSrv.vjsPlayer.ima.controller.playerWrapper.onVolumeChange();
        }
        document.querySelector('.linkOut').style.zIndex = '1110';
        this.findImaViewTags();
        this.fixImaZIndex('1297');
        this.updateUI(ad, adEvent.getAdData(), adEvent);
      }
      if (ad && !ad.isLinear()) {
        document.querySelector('.linkOut').style.zIndex = '9999';
      }
      this.adsPaused = false;
      setTimeout(() => {
        document.querySelector('.ima-ad-container').style.display = 'block';
      }, 500);

    });
    vjsSrv.vjsPlayer.ima.addEventListener(google.ima.AdEvent.Type.AD_PROGRESS, (adEvent) => {
      if (this.ads.ad && this.ads.ad.isLinear()) {
        // this.findImaViewTags();
        // this.fixImaZIndex('1297');
        this.updateUI(this.ads.ad, adEvent.getAdData(), adEvent);
      }
      if (!this.adsPaused) {
        this.uiCustomPlayBtn.hide();
      }
    });
    vjsSrv.vjsPlayer.ima.addEventListener(google.ima.AdEvent.Type.PAUSED, (adEvent) => {
      this.adsPaused = true;
      this.uiCustomPlayBtn.show();
    });
    vjsSrv.vjsPlayer.ima.addEventListener(google.ima.AdEvent.Type.RESUMED, (adEvent) => {
      this.uiCustomPlayBtn.hide();
      this.adsPaused = false;
    });
  }

  findImaViewTags() {
    this.imaViewTags = Array.prototype.slice.call(this.imaContainer.firstElementChild.querySelectorAll('[playsinline="true"]') || []);
    return this.imaViewTags;
  }

  fixImaZIndex(zIndex) {
    this.imaViewTags.map((tag) => {
      tag.style.zIndex = zIndex;
    });
  }

  updateUI(ad, adData, adEvent) {
    if (ad && ad.isLinear() && adData) {
      this.uiWrapper.style.zIndex = '1298';
      this.uiWrapper.show();
      this.uiMuteContainer.show();
      const adPodInfo = ad.getAdPodInfo();
      this.uiAdIdentifier.show();
      if (this.clickThroughUrl) {
        this.uiCustomClickBtn.show();
      } else {
        this.uiCustomClickBtn.hide();
      }
      if (ad.isSkippable()) {
        this.adSkipBlock.show();
        if (!this.adsManager.getAdSkippableState()) {
          this.uiSkipInfoEl.show();
          let leftForSkip = this.adsManager.getRemainingTime() < 0 || adData.duration < 0 ? ad.getSkipTimeOffset() : ad.getSkipTimeOffset() - (adData.duration - this.adsManager.getRemainingTime());
          this.uiSkipInfoEl.innerHTML = vjsSrv.vjsPlayer.localize('Skip in {1} sec', [Math.floor(leftForSkip || 0)]);
          this.uiSkipBtn.hide();
          this.uiSkipBtn.disabled = true;
        } else {
          this.uiSkipInfoEl.hide();
          this.uiSkipBtn.show();
          this.uiSkipBtn.disabled = false;
        }
      } else {
        this.uiSkipInfoEl.hide();
        this.uiSkipBtn.hide();
      }
      {
        let min = Math.floor(this.adsManager.getRemainingTime() / 60);
        let sec = Math.floor(this.adsManager.getRemainingTime() - (min * 60));
        this.uiRemindTimeEl.innerHTML = `${min < 10 ? '0' + min : min}:${sec < 10 ? '0' + sec : sec}`;
        if (adPodInfo.getTotalAds() > 1) {
          this.uiPodsCounted.innerHTML = vjsSrv.vjsPlayer.localize(`{1} of {2}`, [adPodInfo.getAdPosition(), adPodInfo.getTotalAds()]);
          this.uiPodsCounted.show();
          this.uiSpacerDotEl.show();
          this.adSkipBlock.show();
        } else {
          this.uiPodsCounted.hide();
          this.uiSpacerDotEl.hide();
          if (!ad.isSkippable()) {
            this.adSkipBlock.hide();
          }
        }
        this.uiCountdownWrap.show();
      }
    }
  }

  resetUIWrap() {
    this.uiRemindTimeEl.innerHTML = `00:00`;
    this.uiSkipInfoEl.innerHTML = vjsSrv.vjsPlayer.localize('Skip in {1} sec', [0]);
    this.uiSpacerDotEl.show();
    this.uiPodsCounted.innerHTML = vjsSrv.vjsPlayer.localize(`{1} of {2}`, [0, 0]);
    this.uiPodsCounted.show();

    this.uiWrapper.hide();
    this.uiWrapper.style.zIndex = '1100';
    this.uiCountdownWrap.hide();
    this.uiAdIdentifier.hide();
    this.uiCustomClickBtn.hide();
    this.uiCustomPlayBtn.hide();
    this.uiMuteContainer.hide();
    document.querySelector('.linkOut').style.zIndex = '9999';
  }

  _createCustomPlayBtn() {
    this.uiCustomPlayBtn = document.createElement('div');
    this.uiCustomPlayBtn.classList.add('vjs-big-play-button');
    this.uiCustomPlayBtn.innerHTML = `<span class="vjs-icon-placeholder" aria-hidden="true"></span>`;
    this.uiCustomPlayBtn.addEventListener('click', () => {
      this.adsManager.resume();
    });
    this.uiCustomPlayBtn.show = () => {
      this.uiCustomPlayBtn.classList.remove('d-none');
      this.uiCustomPlayBtn.classList.add('d-block');
    };
    this.uiCustomPlayBtn.hide = () => {
      this.uiCustomPlayBtn.classList.add('d-none');
      this.uiCustomPlayBtn.classList.remove('d-block');
    };

    this.uiCustomPlayBtn.hide();
    this.uiWrapper.appendChild(this.uiCustomPlayBtn);
  }

  _onIframeClick() {
    console.log('[ads][ui] open link by click on iframe', ctx.clickThroughUrl);
    window.open(`${ctx.clickThroughUrl}`);
  }


  _createCustomClickBtn() {
    this.uiCustomClickBtn = document.createElement('a');
    this.uiCustomClickBtn.show = () => {
      this.uiCustomClickBtn.classList.remove('d-none');
      if (device.isAnyMobile() && !device.isIpad()) {
        this.uiCustomClickBtn.setAttribute('href', this.clickThroughUrl);
        this.uiCustomClickBtn.setAttribute('target', '_blank');
      } else {
        let rect = this.uiCustomClickBtn.getBoundingClientRect();
        let imaIframe = this.imaContainer.querySelector('[id^="goog_"]');
        imaIframe.classList.add('ads-fake-open-btn');
        imaIframe.style.position = 'absolute';
        imaIframe.style.width = (rect.width) + 134 + 'px';
        imaIframe.style.height = rect.height + 'px';
        if (device.isIpad()) {
          imaIframe.removeEventListener('click', this._onIframeClick);
          imaIframe.addEventListener('click', this._onIframeClick);
        }
      }
    };
    this.uiCustomClickBtn.hide = () => {
      this.uiCustomClickBtn.setAttribute('href', 'javascript:;');
      this.uiCustomClickBtn.classList.add('d-none');
      if (!device.isAnyMobile() || device.isIpad()) {
        if (!this.imaContainer) {
          return;
        }
        let imaIframe = this.imaContainer.querySelector('[id^="goog_"]');
        if (imaIframe) {
          imaIframe.removeEventListener('click', this._onIframeClick);
          imaIframe.classList.remove('ads-fake-open-btn');
          imaIframe.style.position = 'relative';
          imaIframe.style.width = 'inherit';
          imaIframe.style.height = 'inherit';
        }
      }
    };

    this.uiCustomClickBtn.addEventListener('click', ($event) => {
      this.adsManager.pause();
    });

    this.uiCustomClickBtn.innerHTML = `
      <div class="ad-click-btn-title">${vjsSrv.vjsPlayer.localize('Open website')}</div>
      <svg class="open-icon" width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_161_61)">
          <path d="M9.89808 5.46597H9.12119C8.96029 5.46597 8.82985 5.59641 8.82985 5.7573V9.29941C8.82985 9.48742 8.67684 9.64039 8.48883 9.64039H1.70043C1.51246 9.64039 1.35957 9.48742 1.35957 9.29941V2.51111C1.35957 2.32307 1.51246 2.17006 1.70043 2.17006H5.4239C5.58479 2.17006 5.71524 2.03962 5.71524 1.87872V1.10182C5.71524 0.940927 5.58479 0.810486 5.4239 0.810486H1.70043C0.762796 0.810486 0 1.5734 0 2.51111V9.29945C0 10.2372 0.762834 11 1.70043 11H8.48879C9.42651 11 10.1894 10.2371 10.1894 9.29945V5.75734C10.1894 5.59641 10.059 5.46597 9.89808 5.46597Z" fill="white"/>
          <path d="M10.7076 0H7.61739C7.45649 0 7.32605 0.130441 7.32605 0.291336V1.06823C7.32605 1.22913 7.45649 1.35957 7.61739 1.35957H8.67801L4.68689 5.3506C4.57312 5.46438 4.57312 5.64881 4.68689 5.76263L5.23624 6.31201C5.29089 6.36667 5.36497 6.39735 5.44227 6.39735C5.51953 6.39735 5.59365 6.36667 5.64827 6.31201L9.63938 2.3209V3.38148C9.63938 3.54238 9.76982 3.67282 9.93071 3.67282H10.7076C10.8685 3.67282 10.9989 3.54238 10.9989 3.38148V0.291336C10.9989 0.130441 10.8685 0 10.7076 0Z" fill="white"/>
        </g>
        <defs>
          <clipPath id="clip0_161_61">
            <rect width="11" height="11" fill="white"/>
          </clipPath>
        </defs>
      </svg>
    `;
    this.uiCustomClickBtn.classList.add('ad-click-btn');
    this.uiCustomClickBtn.classList.add('ad-custom-el');
    this.uiCustomClickBtn.hide();
    this.uiWrapperRow.appendChild(this.uiCustomClickBtn);
  }

  _createAdIdentifier() {
    this.uiAdIdentifier = document.createElement('div');

    this.wrapHtmlEl(this.uiAdIdentifier);
    this.uiAdIdentifier.classList.add('ad-identifier');
    this.uiAdIdentifier.innerHTML = 'AD';
    this.uiAdIdentifier.hide();
    this.uiWrapper.appendChild(this.uiAdIdentifier);
  }

  _createCustomCountdown() {
    this.uiCountdownWrap = document.createElement('div');
    this.uiCountdownWrap.classList.add('ad-custom-el');
    this.uiCountdownWrap.classList.add('ad-custom-countdown');
    this.uiCountdownWrap.innerHTML = `
    <div class="ad-remind-time">00:00</div>
    <div class="ad-skip-block">
      <span class="ad-skip-info">${vjsSrv.vjsPlayer.localize('Skip in {1} sec', [0])}</span>
      <button type="button" class="ad-skip-btn">${vjsSrv.vjsPlayer.localize('Skip')}</button>
      <span class="ad-spacer-dot"></span>
      <span class="ad-pods-counter">${vjsSrv.vjsPlayer.localize(`{1} of {2}`, [0, 0])}</span>
    </div>
    `;
    this.uiSpacerDotEl = this.uiCountdownWrap.querySelector('.ad-spacer-dot');
    this.uiSkipInfoEl = this.uiCountdownWrap.querySelector('.ad-skip-info');
    this.uiRemindTimeEl = this.uiCountdownWrap.querySelector('.ad-remind-time');
    this.uiSkipBtn = this.uiCountdownWrap.querySelector('.ad-skip-btn');
    this.uiPodsCounted = this.uiCountdownWrap.querySelector('.ad-pods-counter');
    this.adSkipBlock = this.uiCountdownWrap.querySelector('.ad-skip-block');

    this.uiSkipBtn.addEventListener('click', () => {
      if (this.adsManager.getAdSkippableState()) {
        this.adsManager.skip();
      }
    });

    this.wrapHtmlEl(this.uiSkipInfoEl);
    this.wrapHtmlEl(this.uiSkipBtn);
    this.wrapHtmlEl(this.uiPodsCounted);
    this.wrapHtmlEl(this.uiCountdownWrap);
    this.wrapHtmlEl(this.uiSpacerDotEl);
    this.wrapHtmlEl(this.adSkipBlock);
    this.uiCountdownWrap.hide();
    this.uiWrapperRow.appendChild(this.uiCountdownWrap);
  }

  _createMuteContainer() {
    /** mute container */
    this.uiMuteContainer = document.createElement('div');
    this.uiMuteContainer.classList.add('mute-container');
    this.uiWrapperRow.appendChild(this.uiMuteContainer);
    this.wrapHtmlEl(this.uiMuteContainer);
    console.dir(this.uiMuteContainer);
    // this.uiCustomClickBtn = document.createElement('div');
    /** mute container */
  }

  _wrapMuteControl() {
    if (!this.uiMuteContainer.firstElementChild) {
      const imaMute = document.querySelector('.ima-mute-div');
      const imaVolumeSlider = document.querySelector('.ima-slider-div');
      imaVolumeSlider.parentNode.removeChild(imaVolumeSlider);
      imaMute.parentNode.removeChild(imaMute);
      this.uiMuteContainer.appendChild(imaMute);
      if (!device.isAnyMobile()) {
        this.uiMuteContainer.appendChild(imaVolumeSlider);
      }
    }
  }

  preInit() {
    this.uiWrapper = document.createElement('div');
    this.uiWrapper.classList.add('ads-ui-wrapper');
    this.uiWrapperRow = document.createElement('div');
    this.uiWrapperRow.classList.add('ads-ui-controls');
    this.uiWrapper.appendChild(this.uiWrapperRow);
    this.wrapHtmlEl(this.uiWrapper);
    this._createCustomClickBtn();
    this._createMuteContainer();
    this._createCustomPlayBtn();
    this._createAdIdentifier();
    this._createCustomCountdown();
  }

  init() {
    this.addListeners();
    this.imaContainer = document.querySelector('.ima-ad-container');
    this.imaContainer.appendChild(this.uiWrapper);
    this._wrapMuteControl();
  }
}